module.exports = __webpack_public_path__ + "static/media/test1 (26).c548d275.jpg";